
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.137 4.506a4.49 4.49 0 013.432 3.432M12.137 1c3.581.373 6.416 3.208 6.864 6.864M18.105 14.802v2.611c0 .97-.747 1.716-1.716 1.716h-.15a17.521 17.521 0 01-7.46-2.611c-2.09-1.343-3.88-3.06-5.149-5.148a16.022 16.022 0 01-2.61-7.461c-.15-1.045.596-1.94 1.566-2.014h2.686c.895 0 1.567.596 1.716 1.492.074.82.298 1.641.597 2.462.223.597.074 1.343-.373 1.79l-1.12 1.12a13.138 13.138 0 005.149 5.148l1.119-1.12c.447-.447 1.193-.596 1.79-.373a8.627 8.627 0 002.388.597c.97.15 1.641.896 1.567 1.79z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    